import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Navbar from "../components/navbar";
import About from "../components/about";
import Features from "../components/features";

import GetInTuch from "../components/getInTuch";
import Footer from "../components/footer";

import Switcher from "../components/switcher";

import Beneficios from "../components/Beneficios";
import Ecosistema from "../components/Ecosistema";
import WordWide from "../components/WordWide";

import VideoBackground from "../components/VideoBackground";

import HubspotScript from "../components/husbspotScript";
import CarouselTestimonios from "../components/CarouselTestimonios";
import CertificacionesCarousel from "../components/CertificacionesCarousel";
import PalabrasCarousel from "../components/PalabrasCarousel";
import Cookie from "../components/Cookie";
import useStore from "../store/useStore";

export default function Index() {
  const location = useLocation();
  const { home, getHomeHero } = useStore();
  useEffect(() => {
    getHomeHero();
  }, [getHomeHero]);

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 100);
    }
  }, [location]);
  const urlApi = "https://api.institucional.global.sidom.io";
  return (
    <>
      <main className="relative overflow-hidden leading-[1.3] bg-sidom-light dark:bg-sidom-blue">
        <header>
          <Navbar />
        </header>
        <main>
          <section data-aos="fade-up" aria-label="Hero principal">
            {home?.length === 0 || !home ? (
              <VideoBackground
                video="/placeholder.mp4"
                titulo1="Cargando..."
                titulo2="Espere un momento"
                textbutton="SOLICITAR DEMO"
                logo="/placeholder-logo.png"
              />
            ) : (
              home.map((item, index) => (
                <VideoBackground
                  key={index}
                  video={`${urlApi}${item.video[0]?.url}`}
                  titulo1={item.titulo}
                  titulo2={item.text}
                  textbutton="SOLICITAR DEMO"
                  link="/contacto"
                  logo={`${urlApi}${
                    item.img?.formats?.thumbnail?.url ||
                    item.img?.url ||
                    "/placeholder-logo.png"
                  }`}
                />
              ))
            )}
          </section>

          <section aria-label="Sobre nosotros">
            <About />
          </section>

          <section aria-label="Testimonios de clientes">
            <PalabrasCarousel />
          </section>

          <section
            id="section-two"
            data-aos="fade-up"
            data-aos-delay="300"
            aria-label="Características"
          >
            <Features />
          </section>

          <section
            data-aos="fade-up"
            data-aos-delay="400"
            aria-label="Testimonios"
          >
            <CarouselTestimonios />
          </section>

          <section
            data-aos="fade-up"
            data-aos-delay="500"
            aria-label="Presencia mundial"
          >
            <WordWide />
          </section>

          <section
            data-aos="fade-up"
            data-aos-delay="600"
            aria-label="Beneficios"
          >
            <Beneficios />
          </section>

          <section aria-label="Certificaciones">
            <CertificacionesCarousel />
          </section>

          <section aria-label="Ecosistema">
            <Ecosistema />
          </section>
        </main>
        <section aria-label="Contacto">
          <GetInTuch />
        </section>
      </main>
      <Cookie />
      <HubspotScript />

      <footer>
        <Footer />
      </footer>

      <Switcher />
    </>
  );
}
